import * as React from 'react'

const PhotoUploadIcon = (props: { className?: string }) => {
  return (
    <svg
      className={'icon ' + props.className}
      width='96'
      height='96'
      viewBox='0 0 96 96'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='96' height='96' fill='black' fillOpacity='0' />
      <circle cx='48' cy='48' r='48' fill='#F5F6F7' />
      <rect width='62' height='42' fill='black' fillOpacity='0' transform='translate(17 26)' />
      <path
        d='M71.11 41.8457C71.2046 41.2374 71.25 40.6186 71.25 40C71.25 32.2822 64.2985 26 55.75 26C50.7927 26 46.2404 28.1158 43.3568 31.585C42.3389 31.3628 41.3021 31.25 40.25 31.25C32.7725 31.25 26.6875 36.7461 26.6875 43.5C26.6875 43.671 26.6913 43.8384 26.6989 44.0059C21.0945 45.5098 17 50.2061 17 55.75C17 62.5039 23.085 68 30.5625 68H63.5C72.0485 68 79 61.7212 79 54C79 48.897 75.8932 44.2862 71.11 41.8457ZM63.5 64.5H30.5625C25.2116 64.5 20.875 60.583 20.875 55.75C20.875 50.917 25.2117 47 30.5625 47C30.8577 47 31.1377 47.0547 31.4253 47.0786C30.8804 45.9849 30.5625 44.7784 30.5625 43.5C30.5625 38.6669 34.8992 34.75 40.25 34.75C41.9984 34.75 43.618 35.2012 45.0332 35.9327C46.7891 32.1523 50.9251 29.5 55.75 29.5C62.1717 29.5 67.375 34.1997 67.375 40C67.375 41.3809 67.0609 42.6934 66.5236 43.9034C71.4695 45.1133 75.125 49.1534 75.125 54C75.125 59.8003 69.9217 64.5 63.5 64.5Z'
        fill='white'
      />
      <path
        d='M63.5 64.5H30.5625C25.2116 64.5 20.875 60.583 20.875 55.75C20.875 50.917 25.2117 47 30.5625 47C30.8577 47 31.1377 47.0547 31.4253 47.0786C30.8804 45.9849 30.5625 44.7784 30.5625 43.5C30.5625 38.6669 34.8992 34.75 40.25 34.75C41.9984 34.75 43.618 35.2012 45.0332 35.9327C46.7891 32.1523 50.9251 29.5 55.75 29.5C62.1717 29.5 67.375 34.1997 67.375 40C67.375 41.3809 67.0609 42.6934 66.5236 43.9034C71.4695 45.1133 75.125 49.1534 75.125 54C75.125 59.8003 69.9217 64.5 63.5 64.5Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M48.9613 49.4458L54.3972 54.9952L52.4753 56.9572L49.3597 53.7765L49.3593 67.9997H46.6414V53.7761L43.5254 56.9572L41.6035 54.9952L48.0003 48.4648L48.9613 49.4458Z'
        fill='#F5F6F7'
      />
    </svg>
  )
}

export default PhotoUploadIcon



// WEBPACK FOOTER //
// ./src/components/icons/ui/PhotoUploadIcon.tsx